// Copyright (c) StrangeBee 2024

import React, { ReactElement, ReactNode } from 'react';
import { ColorsType, FillType } from '@Types';
import { classList } from '@Helpers/className';

import './ColorLabel.scss';

interface ColorLabelProps {
    label: ReactNode;
    color: ColorsType | string;
    type?: FillType;
    className?: string;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

function getContrastYIQ(hexcolor: string) {
    hexcolor = hexcolor.replace('#', '');
    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? '#333' : 'white';
}

export const ColorLabel = ({
    label,
    color,
    type = 'outline',
    className = '',
    onClick,
    onMouseEnter,
    onMouseLeave,
}: ColorLabelProps): ReactElement => {
    const isCustomColor = color.startsWith('#');

    return (
        <span
            className={classList('color-label', className, type, {
                'color-label__click': !!onClick,
                [`${type}-${color}`]: !isCustomColor,
                'custom-color': isCustomColor,
            })}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            style={{
                ['--color-label' as string]: isCustomColor ? color : null,
                ['--color-font' as string]: isCustomColor ? getContrastYIQ(color) : null,
            }}
        >
            <span className="color-label__content">{label}</span>
        </span>
    );
};
